import { render, staticRenderFns } from "./catEdit.vue?vue&type=template&id=6346b7c4&"
import script from "./catEdit.vue?vue&type=script&lang=js&"
export * from "./catEdit.vue?vue&type=script&lang=js&"
import style0 from "./catEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports